export const financePagePOTooltip = (po) => {
    return (po?.skuTotal || []).map((product) => {
        return `${product.excluded ? "(EXCLUDED) " : ""}${product.product_name} (${product.product_sku}) - ${product.total_box_received}/${product.total_box_qty}`;
    }).join('<br />');
}